// CacheKey 3b9b8fa9e0f853fb30b0f9550bcb4c0b
//
// DO NOT MODIFY: This file was automatically generated by JsFromTranslations.
export default {
  en: {
    dynamic_services: {
      error_codes: {
        e10ERROR: "ERROR (failed)",
        e20ERROR: "Coupon retrieval failed",
        e20001: "No coupon available",
        e20002: "Patient exceeded limit of allowed medications",
        e20003: "Coupon retrieval failed",
        e20004: "Coupon retrieval failed",
        e20005: "Coupon retrieval failed",
        e20006: "Invalid token",
        e20007: "Coupon retrieval failed"
      }
    }
  }
}

